import { appConfig } from "#web/configs/app";
import { Client } from "@gadget-client/keepcart-server";

export const api = new Client({
  environment: appConfig.environment,
});
